import axios from "./Axios";

export const callOpenAIAPI = async (data) => {
  return await axios.post("/testapi/post", data); // Update the URL as needed
};
